<template>
	<!-- Short-link domain a campaign prints (Settings → Short Links). null = the default domain. -->
	<div class="w-100">
		<select :id="id" class="form-select" :value="value || ''" :disabled="loading || !domains.length" @change="$emit('input', $event.target.value || null)">
			<option value="">Default{{ defaultDomain ? ` — ${defaultDomain.label} (${host(defaultDomain)})` : '' }}</option>
			<option v-for="domain in domains" :key="domain.id" :value="domain.id">{{ domain.label }} ({{ host(domain) }})</option>
		</select>
		<small v-if="!loading && !domains.length" class="form-text text-muted d-block">No short domains yet — add them in Settings → Short Links.</small>
		<small v-else-if="value && !selectedExists" class="form-text text-warning d-block">This domain no longer exists; the default domain is used.</small>
		<small v-else class="form-text text-muted d-block">Printed as <code>{{ example }}</code>. Recipients that already have a link keep their host.</small>
	</div>
</template>

<script>
import restApi from '@/api/index'

export default {
	name: 'ShortlinkDomainSelect',
	props: {
		value: { type: String, default: null },
		id: { type: String, default: null },
	},
	data() {
		return { loading: true, domains: [] }
	},
	computed: {
		defaultDomain() {
			return this.domains.find(domain => domain.is_default) || this.domains[0] || null
		},
		selectedExists() {
			return this.domains.some(domain => domain.id === this.value)
		},
		example() {
			const domain = (this.value && this.domains.find(item => item.id === this.value)) || this.defaultDomain
			return `${domain ? this.host(domain) : 'twn.link'}/a7k2m`
		},
	},
	async created() {
		try {
			const { data } = await restApi.get('/shortlink-domains')
			this.domains = data || []
		} catch (error) {
			this.domains = []
		} finally {
			this.loading = false
		}
	},
	methods: {
		host(domain) {
			return String(domain.host || '').replace(/^https?:\/\//, '').replace(/\/+$/, '')
		},
	},
}
</script>
